import type { FC, PropsWithChildren } from 'react';
import { Modal, ModalForm, InputsSection, InputBox, ModalButtons } from '../../../components/Modal';
import ModalHeading from '../../../components/Modal/ModalHeading';
import DeleteModalSkeleton from '../../../Skeletons/DeleteModalSkeleton';
import { IClinicNew } from '../../../hooks/clinic/index.type';

export type DeleteModalState = PropsWithChildren<{
  status: boolean;
  data?: IClinicNew;
}>;

export type IdeleteModalStates = PropsWithChildren<{
  email: { value: string; error: string };
}>;

type AddEditModalProps = PropsWithChildren<{
  loading: boolean;
  deleteModal: DeleteModalState;
  deleteModalStates: IdeleteModalStates;
  setDeleteModalStates: React.Dispatch<React.SetStateAction<IdeleteModalStates>>;
  onCloseModal?: () => void;
  handleDelete?: (event: React.FormEvent<HTMLFormElement>) => void;
}>;

const DeleteModal: FC<AddEditModalProps> = props => {
  return (
    <Modal show={props.deleteModal.status}>
      <ModalHeading heading={`Delete ${props.deleteModal.data?.name}`} />
      {props.loading ? (
        <DeleteModalSkeleton />
      ) : (
        props.deleteModal.data && (
          <ModalForm style={{ marginBottom: '2.5rem' }} onSubmit={props.handleDelete}>
            <InputsSection style={{ width: '34rem', flexWrap: 'wrap' }}>
              <InputBox
                label={`Enter ${props.deleteModal.data.email} to delete this clinic`}
                placeholder={props.deleteModal.data.email}
                value={props.deleteModalStates.email.value}
                onChange={event => {
                  props.setDeleteModalStates(prevVal => ({ ...prevVal, email: { value: event.target.value, error: '' } }));
                }}
                errorMessage={props.deleteModalStates.email.error}
                style={{ width: '30rem' }}
              />
              <p className='dangerText'>Please note that this will delete clinic entire data and will not be restored in future.</p>
            </InputsSection>
            <InputsSection style={{ width: '34rem' }}>
              <p className='primaryText'>
                If your intension is to restrict this clinic users from logging in, we recommend to change active status to false instead of deleting the clinic.
              </p>
            </InputsSection>
            <ModalButtons submitButtonLabel='Delete Clinic' cancelButtonLabel='Cancel' onCancel={props.onCloseModal} />
          </ModalForm>
        )
      )}
    </Modal>
  );
};

export default DeleteModal;
